export function toMoney(value: number | string) {
  if (typeof value === "string") {
    value = parseFloat(value);
  }
  return Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
  }).format(value);
}